import { isArray, isNumber, xor } from 'lodash-es'

export const itemKey = (item) => `${item.is_org ? 'org' : 'building'}-${item.id}`

export const isSameData = (a, b) => {
  if (a == b) {
    return true
  }

  if (isNumeric(a) || isNumeric(b)) {
    return Number(a) === Number(b)
  }

  if (isArray(a) && isArray(b)) {
    return xor(a, b).length === 0
  }

  return false
}

export const updateUrl = (item, buildingId) => {
  const base = `/buildings/${buildingId}/questionnaires/price`
  return item.is_new || item.is_org ? base : `${base}/${item.id}`
}

function isNumeric(str) {
  if (typeof str != 'string') return false // we only process strings!
  return (
    !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    !isNaN(parseFloat(str))
  ) // ...and ensure strings of whitespace fail
}
